import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Ref, ref } from 'vue';
import IconWave from '@/components/icons/IconWave.vue';
import IconWaveFlip from '@/components/icons/IconWaveFlip.vue';
import IconWaveNegativ from '@/components/icons/IconWaveNegativ.vue';
import IconWaveNegativFlip from '@/components/icons/IconWaveNegativFlip.vue';
import IconWaveDouble from '@/components/icons/IconWaveDouble.vue';
import IconWaveDoubleFlip from '@/components/icons/IconWaveDoubleFlip.vue';
import IconWaveDoubleNegativ from '@/components/icons/IconWaveDoubleNegativ.vue';
import IconWaveDoubleNegativFlip from '@/components/icons/IconWaveDoubleNegativFlip.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'IoWave',
  props: {
  waveType: {
    type: String,
    required: false,
    default: () => 'none',
  },
  background: {
    type: String,
    required: false,
    default: () => 'white',
  },
  waveMirrored: {
    type: Boolean,
    default: false,
  },
  waveNegative: {
    type: Boolean,
    default: false,
  },
  maskId: String,
},
  setup(__props, { expose: __expose }) {


const props = __props;

const wave = ref();

__expose<{
  rootEl: Ref<HTMLElement>,
}>({
  rootEl: wave,
});

return (_ctx: any,_cache: any) => {
  return (props.waveType === 'wave' && !props.waveNegative && !props.waveMirrored)
    ? (_openBlock(), _createBlock(IconWave, {
        key: 0,
        ref_key: "wave",
        ref: wave,
        "mask-id": __props.maskId,
        class: "app-wave wave"
      }, null, 8, ["mask-id"]))
    : (props.waveType === 'wave' && !props.waveNegative && props.waveMirrored)
      ? (_openBlock(), _createBlock(IconWaveFlip, {
          key: 1,
          ref_key: "wave",
          ref: wave,
          "mask-id": __props.maskId,
          class: "app-wave wave-flip"
        }, null, 8, ["mask-id"]))
      : (props.waveType === 'wave' && props.waveNegative && !props.waveMirrored)
        ? (_openBlock(), _createBlock(IconWaveNegativ, {
            key: 2,
            ref_key: "wave",
            ref: wave,
            "mask-id": __props.maskId,
            class: "app-wave wave-negativ"
          }, null, 8, ["mask-id"]))
        : (props.waveType === 'wave' && props.waveNegative && props.waveMirrored)
          ? (_openBlock(), _createBlock(IconWaveNegativFlip, {
              key: 3,
              ref_key: "wave",
              ref: wave,
              "mask-id": __props.maskId,
              class: "app-wave wave-negativ-flip"
            }, null, 8, ["mask-id"]))
          : (props.waveType === 'double-wave' && !props.waveNegative && !props.waveMirrored)
            ? (_openBlock(), _createBlock(IconWaveDouble, {
                key: 4,
                ref_key: "wave",
                ref: wave,
                "mask-id": __props.maskId,
                class: "app-wave double-wave"
              }, null, 8, ["mask-id"]))
            : (props.waveType === 'double-wave' && !props.waveNegative && props.waveMirrored)
              ? (_openBlock(), _createBlock(IconWaveDoubleFlip, {
                  key: 5,
                  ref_key: "wave",
                  ref: wave,
                  "mask-id": __props.maskId,
                  class: "app-wave double-wave-flip"
                }, null, 8, ["mask-id"]))
              : (props.waveType === 'double-wave' && props.waveNegative && !props.waveMirrored)
                ? (_openBlock(), _createBlock(IconWaveDoubleNegativ, {
                    key: 6,
                    ref_key: "wave",
                    ref: wave,
                    "mask-id": __props.maskId,
                    class: "app-wave double-wave-negativ"
                  }, null, 8, ["mask-id"]))
                : (_openBlock(), _createBlock(IconWaveDoubleNegativFlip, {
                    key: 7,
                    ref_key: "wave",
                    ref: wave,
                    "mask-id": __props.maskId,
                    class: "app-wave double-wave-negativ-flip"
                  }, null, 8, ["mask-id"]))
}
}

})